var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.754 7.016v7.615c0 .441-.153.687-.492.8-.524.175-.971-.15-1.015-.738-.005-.07 0-.138 0-.208V7.029c-.084.072-.141.115-.192.161L8.337 9.705c-.332.31-.658.361-.955.156-.437-.302-.48-.82-.09-1.214.238-.24.494-.466.742-.698l3.343-3.122c.472-.44.79-.434 1.258.008 1.337 1.259 2.678 2.514 4.009 3.78.152.136.267.308.333.5.09.333-.1.588-.378.763-.25.157-.5.132-.74-.036a3.438 3.438 0 0 1-.333-.275l-2.58-2.39a6.204 6.204 0 0 1-.192-.161z",
    fill: "#F89521"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.01 20.477c-1.31 0-2.62.005-3.93 0-.962 0-1.771-.355-2.393-1.098-.48-.574-.666-1.256-.68-1.987-.013-.68-.005-1.36 0-2.04 0-.45.207-.742.573-.831.473-.119.896.166.923.66.025.428.008.86.013 1.289.005.38-.012.764.03 1.141.09.827.675 1.357 1.514 1.36 2.628.01 5.256.01 7.884 0 .927 0 1.54-.647 1.544-1.577.004-.679 0-1.359 0-2.039 0-.469.212-.754.611-.843a.71.71 0 0 1 .88.624c.027.282.015.568.016.852 0 .52.014 1.04-.008 1.56-.072 1.71-1.331 2.92-3.045 2.93-1.31.007-2.62 0-3.931 0z",
    fill: "#F89521"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.1ae27bb156cd6e26fda2741e3e5de729.svg";
export { ForwardRef as ReactComponent };